// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VuexRouterSync from 'vuex-router-sync'
import ElementUI from 'element-ui'
import lang from '@/assets/lang/vi'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

import App from './App'
import router from './router'
import store from './store'
import { i18n } from './plugins/i18n'
import * as filters from './filters'
import authService from './services/auth'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import OtpInput from '@bachdgvn/vue-otp-input'

VuexRouterSync.sync(store, router)
Vue.router = router

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.API_URL
if (store.state.auth.access_token) {
  Vue.axios.defaults.headers.common['Authorization'] = 'Token ' + store.state.auth.access_token
}
Vue.axios.defaults.withCredentials = true

Vue.use(ElementUI)

Vue.component('v-otp-input', OtpInput)

// configure language
locale.use(lang)
require('moment/locale/vi')
require('moment-timezone')
Vue.use(VueMoment, { moment })

authService.check()

Vue.axios.interceptors.response.use(function (res) {
  return res
}, function (err) {
  if (err.response) {
    const errCode = err.response.status
    switch (errCode) {
      case 401:
        window.localStorage.removeItem('access_token')
        if (router.history.current.name !== 'login') {
          router.push('/login')
        }
        break
      case 500:
        router.push('/500')
        break
      default:
        return Promise.reject(err)
    }
  }
})

Vue.config.productionTip = false

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js